module.exports = __webpack_public_path__ + "img/53_24.d64ba7d9.png";